import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  TierExpirationDate as TierExpirationDateComponent,
  TierExpirationDateProps,
} from "../../components/TierExpirationDate";
import { getMemberTierCustomerAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";

interface TierExpirationDateContainerProps extends TierExpirationDateProps {
  getMemberTierCustomerAction: typeof getMemberTierCustomerAction;
  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
}

class TierExpirationDate extends React.Component<TierExpirationDateContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated && !this.props.isLoading) {
      this.props.getMemberTierCustomerAction();
    }
  }

  render() {
    return <TierExpirationDateComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsMemberTierLoading(state),
  memberTierCustomer: getMemberTierCustomer(state),
});

export default connect(mapStateToProp, {
  getMemberTierCustomerAction,
})(TierExpirationDate);
